import { CeruleanButton } from 'components/Button'
import I18n from 'components/I18n'
import _Modal from 'components/Modal'
import { actions, selectors } from 'data'
import messages from 'lang'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import { color } from 'utils'

const Modal = styled(_Modal)`
  background: ${color('dark800')};
  padding: 1.5rem;
  border-radius: 0.5rem;
  height: 18rem;
  width: 33rem;

  h1 {
    color: ${color('white')};
    font-weight: 600;
    font-size: 1.5rem;
    line-height: 135%;
  }

  p {
    color: ${color('dark')};
    font-weight: 500;
    font-size: 0.875rem;
    line-height: 150%;
  }
`

const CheckAllowedAddress = ({ children }) => {
  const user = useSelector(selectors.auth.getUser)
  const config = useSelector(selectors.config.getConfig)
  const dispatch = useDispatch()
  const countries = useSelector(selectors.app.getExchangeAllowedCountries)
  const usStates = useSelector(selectors.app.getRawUsStates)
  const [notified, setNotified] = useState(false)

  useEffect(
    function fetchCountriesOnMount() {
      // avoid fetching countries for unauthed visits
      if (user) {
        dispatch(actions.app.getCountries())
      }
    },
    [user]
  )

  if (!config.checkAllowedAddresses || !user?.address || !countries.length || !usStates.length)
    return children

  const notifyUnsuportedSignup = () => {
    dispatch(
      actions.analytics.trackEvent({
        key: 'Sign Up Address Unsupported',
        properties: {
          country: user.address.country,
          country_state: user.address.state,
          email: user.email
        }
      })
    )
    setNotified(true)
  }

  const isAllowedCountry = countries.some((c) => c.code === user.address.country)
  const isSupportedUSState =
    usStates.find((s) => s.code === user.address.state)?.scopes.includes('MERCURY') ?? true
  if (!isAllowedCountry || (user.address.country === 'US' && !isSupportedUSState))
    return (
      <Modal>
        <h1>
          <I18n data={messages.simple_trade_ineligible_title} />
        </h1>
        <p>
          <I18n data={messages.signup_unavailable} />
        </p>
        {!notified && (
          <CeruleanButton type='button' onClick={notifyUnsuportedSignup}>
            <I18n data={messages.notify_email} />
          </CeruleanButton>
        )}
      </Modal>
    )

  return children
}

export default CheckAllowedAddress
